module.exports = __webpack_public_path__ + "img/bm7.82f96387.png";